import { SetStateAction } from 'react'
import { cargoTypes, SLOT_FORM_ROUTE } from '../../utils/constants'
import { Toggle } from '../toggle/Toggle'
import classes from './CargoSelector.module.sass'
import { CargoSizeItem } from './components/cargoSizeItem/CargoSizeItem'
import SelectorItem from './components/selectorItem/SelectorItem'
import { useCargoSelector } from './hooks/useCargoSelector'
import {
  CargoItemInterface,
  SlotItemInterface,
  TransportItemInterface,
} from '../../types/interfaces'
import { useLocation } from 'react-router-dom'

type Props = {
  topData: TransportItemInterface | CargoItemInterface | SlotItemInterface
  setTopData: React.Dispatch<
    SetStateAction<TransportItemInterface | CargoItemInterface | SlotItemInterface>
  >
  setCargoTypeValid: React.Dispatch<SetStateAction<boolean>>
}

export const CargoSelector = ({ setTopData, setCargoTypeValid, topData }: Props) => {
  const {
    units,
    addUnit,
    toggleType,
    type,
    on,
    setOn,
    unitsOn,
    setUnitsOn,
    deleteUnit,
    inputHandler,
    unitNotValid,
    setUnitPattern
  } = useCargoSelector(setTopData, setCargoTypeValid, topData)
  const location = useLocation()

  return (
    <div className={classes.Container}>
      <div className={classes.ToggleContainer}>
        <Toggle id={'on'} onChange={() => setOn((prev) => !prev)} checked={on} />
        <div>Указать параметры груза</div>
      </div>
      {on && (
        <>
          <div className={classes.Label}>Параметры груза</div>

          <div className={classes.SelectorContainer}>
            {cargoTypes.map((el) => (
              <SelectorItem key={el.id} el={el} onClick={toggleType} value={type} />
            ))}
          </div>
          {!location.pathname.includes(SLOT_FORM_ROUTE) && (
            <>
              <div className={classes.ToggleContainer}>
                <Toggle
                  id={'placesOn'}
                  onChange={() => {
                    setUnitsOn((prev) => !prev)
                  }}
                  checked={unitsOn}
                />
                <div>Заполнить места</div>
              </div>

              {unitsOn &&
                units.map((el, index) => (
                  <CargoSizeItem
                    key={el.uuid}
                    addUnit={index === units.length - 1 ? addUnit : undefined}
                    el={el}
                    index={index}
                    units={units}
                    deleteUnit={deleteUnit}
                    inputHandler={inputHandler}
                    unitNotValid={unitNotValid}
                    setUnitPattern = {setUnitPattern}
                  />
                ))}
            </>
          )}
        </>
      )}
    </div>
  )
}
